import { renderDiverging, renderSequential } from "@gazelab/analysis";
import type { GridDto } from "@gazelab/shared";

export type OverlayMode = "sequential" | "diverging";

export interface OverlaySpec {
  grid: GridDto;
  mode: OverlayMode;
  /** Escala: máximo compartido (secuencial) o máximo absoluto (divergente). */
  max: number;
  opacity: number;
  /** Fracción de `max` por debajo de la cual no se pinta. */
  threshold: number;
}

/** Pinta la matriz en un canvas del tamaño de la rejilla (luego se escala con suavizado). */
export function overlayToCanvas(spec: OverlaySpec): HTMLCanvasElement {
  const { width, height, values } = spec.grid;
  const rgba =
    spec.mode === "sequential"
      ? renderSequential(values, { max: spec.max, opacity: spec.opacity, threshold: spec.threshold })
      : renderDiverging(values, { max: spec.max, opacity: spec.opacity, threshold: spec.threshold });
  const c = document.createElement("canvas");
  c.width = width;
  c.height = height;
  const ctx = c.getContext("2d")!;
  const data = new ImageData(width, height);
  data.data.set(rgba);
  ctx.putImageData(data, 0, 0);
  return c;
}

/** Dibuja imagen + capa en el rectángulo indicado del contexto. */
export function drawImageWithOverlay(
  ctx: CanvasRenderingContext2D,
  image: HTMLImageElement | null,
  overlay: HTMLCanvasElement | null,
  x: number,
  y: number,
  w: number,
  h: number,
) {
  ctx.imageSmoothingEnabled = true;
  ctx.imageSmoothingQuality = "high";
  if (image) ctx.drawImage(image, x, y, w, h);
  if (overlay) ctx.drawImage(overlay, x, y, w, h);
}

export function loadImage(src: string): Promise<HTMLImageElement> {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = () => resolve(img);
    img.onerror = () => reject(new Error("No se pudo cargar la imagen"));
    img.src = src;
  });
}
